import type { ApiResponse } from "../factory";
import { BaseRepository } from "../factory";

export interface ContactUs {
  first_name: string;
  last_name: string;
  email: string;
  mobile?: string;
  company_name: string;
  type?: string;
  message: string;
}

export class ContactUsRepository extends BaseRepository<ContactUs> {
  collection = "contact-us";
  language?: string;

  create(data: ContactUs): Promise<ApiResponse<ContactUs>> {
    return super.create(data);
  }

  constructor(language?: string) {
    super();
    this.language = language;
  }
}
